export default __webpack_public_path__ + "static/NeoSansPro-Regular-0f551dacbc144c5fa79a9c42b663c8ec.woff2";